import { useEffect, useState } from "react";
import { onReconnect } from "@heraion/shared";

/** #397: a counter that grows each time the network comes back while
 *  `failed`. A read hook puts it in its effect's deps to read again. */
export function useRetryOnReconnect(failed: boolean): number {
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    if (!failed) return undefined;
    return onReconnect(() => setRetry((n) => n + 1));
  }, [failed]);
  return retry;
}
